<template>
    <div class="modal-card" style="width: auto">
            <header class="modal-card-head flex justify-between">
                <p class="modal-card-title">
                    Provide Feedback
                </p>
            </header>
            <section class="modal-card-body">
                <d-field label="Feedback">
                    <d-input v-model="form.feedback" type="textarea" />
                </d-field>
                <d-field label="Send Email">
                    <d-checkbox v-model="form.sendEmail" />
                </d-field>
            </section>
            <footer class="modal-card-foot justify-end">
                <d-btn flat @click="$parent.close()">
                    Cancel
                </d-btn>
                <d-btn :loading="saving" type="submit" @click="saveForm()">
                    Save Changes
                </d-btn>
            </footer>
    </div>
</template>

<script>
    import { showErrorToast } from '@services/errorHandling.service';
    import axios from 'axios';

    export default {
        props: {
            quiz: {
                type: Object,
                default: () => ({}),
            }
        },

        data() {
            return {
                saving: false,
                form: {
                    feedback: '',
                    userEmail: '',
                    sendEmail: true
                },
            };
        },

        mounted() {
            this.form.userEmail = this.quiz.userEmail;
            this.form.feedback = this.quiz.feedback;
        },

        methods: {
            async saveForm() {
                this.saving = true;
                try {
                    await axios.post(`/api/subject-areas/content-listings/quiz-reports/${this.quiz.interactionId}/feedback`, this.form)
                    await this.$parent.events.getPaged();
                    this.$parent.close();
                } catch (error) {
                    showErrorToast(error);
                } finally {
                    this.saving = false;
                }
            },
        },
    };
</script>